// SESSION
export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';
export const SIGN_OUT_ERROR = 'SIGN_OUT_ERROR';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export const REFRESH_TOKEN_ERROR = 'REFRESH_TOKEN_ERROR';

// FILTER
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const SET_FILTERS = 'SET_FILTERS';
export const LOAD_FILTERS = 'LOAD_FILTERS';

// SAVED FILTERS
export const SELECT_SAVED_FILTER = 'SELECT_SAVED_FILTER';
export const LOAD_SAVED_FILTERS = 'LOAD_SAVED_FILTERS';
export const LOAD_SAVED_FILTERS_SUCCESS = 'LOAD_SAVED_FILTERS_SUCCESS';
export const LOAD_SAVED_FILTERS_ERROR = 'LOAD_SAVED_FILTERS_ERROR';
export const LOAD_DEFAULT_SAVED_FILTERS = 'LOAD_DEFAULT_SAVED_FILTERS';
export const LOAD_DEFAULT_SAVED_FILTERS_SUCCESS = 'LOAD_DEFAULT_SAVED_FILTERS_SUCCESS';
export const LOAD_DEFAULT_SAVED_FILTERS_ERROR = 'LOAD_DEFAULT_SAVED_FILTERS_ERROR';
export const LOAD_SAVED_FILTER = 'LOAD_SAVED_FILTER';
export const LOAD_SAVED_FILTER_SUCCESS = 'LOAD_SAVED_FILTER_SUCCESS';
export const LOAD_SAVED_FILTER_ERROR = 'LOAD_SAVED_FILTER_ERROR';
export const CREATE_SAVED_FILTER = 'CREATE_SAVED_FILTER';
export const CREATE_SAVED_FILTER_SUCCESS = 'CREATE_SAVED_FILTER_SUCCESS';
export const CREATE_SAVED_FILTER_ERROR = 'CREATE_SAVED_FILTER_ERROR';
export const CLEAR_SAVED_FILTER = 'CLEAR_SAVED_FILTER';
export const DELETE_SAVED_FILTER = 'DELETE_SAVED_FILTER';
export const DELETE_SAVED_FILTER_SUCCESS = 'DELETE_SAVED_FILTER_SUCCESS';
export const DELETE_SAVED_FILTER_ERROR = 'DELETE_SAVED_FILTER_ERROR';

// EXPORT
export const LOAD_EXPORTS = 'LOAD_EXPORTS';
export const LOAD_EXPORTS_SUCCESS = 'LOAD_EXPORTS_SUCCESS';
export const LOAD_EXPORTS_ERROR = 'LOAD_EXPORTS_ERROR';
export const CREATE_EXPORT = 'CREATE_EXPORT';
export const CREATE_EXPORT_SUCCESS = 'CREATE_EXPORT_SUCCESS';
export const CREATE_EXPORT_ERROR = 'CREATE_EXPORT_ERROR';
export const DELETE_EXPORT = 'DELETE_EXPORT';
export const DELETE_EXPORT_SUCCESS = 'DELETE_EXPORT_SUCCESS';
export const DELETE_EXPORT_ERROR = 'DELETE_EXPORT_ERROR';

// INSIGHTS
export const LOAD_INSIGHTS = 'LOAD_INSIGHTS';
export const LOAD_INSIGHTS_SUCCESS = 'LOAD_INSIGHTS_SUCCESS';
export const LOAD_INSIGHTS_ERROR = 'LOAD_INSIGHTS_ERROR';
export const CREATE_INSIGHT = 'CREATE_INSIGHT';
export const CREATE_INSIGHT_SUCCESS = 'CREATE_INSIGHT_SUCCESS';
export const CREATE_INSIGHT_ERROR = 'CREATE_INSIGHT_ERROR';
export const DELETE_INSIGHT = 'DELETE_INSIGHT';
export const DELETE_INSIGHT_SUCCESS = 'DELETE_INSIGHT_SUCCESS';
export const DELETE_INSIGHT_ERROR = 'DELETE_INSIGHT_ERROR';

// CATEGORIES
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const LOAD_CATEGORIES_SUCCESS = 'LOAD_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_ERROR = 'LOAD_CATEGORIES_ERROR';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_CATEGORY_ERROR = 'CREATE_CATEGORY_ERROR';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_ERROR = 'DELETE_CATEGORY_ERROR';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const EDIT_CATEGORY_SUCCESS = 'EDIT_CATEGORY_SUCCESS';
export const EDIT_CATEGORY_ERROR = 'EDIT_CATEGORY_ERROR';
export const LOAD_ALL_CATEGORIES = 'LOAD_ALL_CATEGORIES';
export const LOAD_ALL_CATEGORIES_SUCCESS = 'LOAD_ALL_CATEGORIES_SUCCESS';
export const LOAD_ALL_CATEGORIES_ERROR = 'LOAD_ALL_CATEGORIES_ERROR';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const SELECT_CATEGORY_SUCCESS = 'SELECT_CATEGORY_SUCCESS';

// REPORTS
export const LOAD_REPORTS = 'LOAD_REPORTS';
export const LOAD_REPORTS_SUCCESS = 'LOAD_REPORTS_SUCCESS';
export const LOAD_REPORTS_ERROR = 'LOAD_REPORTS_ERROR';
export const LOAD_REPORT = 'LOAD_REPORT';
export const LOAD_REPORT_SUCCESS = 'LOAD_REPORT_SUCCESS';
export const LOAD_REPORT_ERROR = 'LOAD_REPORT_ERROR';
export const CREATE_REPORT = 'CREATE_REPORT';
export const CREATE_REPORT_SUCCESS = 'CREATE_REPORT_SUCCESS';
export const CREATE_REPORT_ERROR = 'CREATE_REPORT_ERROR';
export const DELETE_REPORT = 'DELETE_REPORT';
export const DELETE_REPORT_SUCCESS = 'DELETE_REPORT_SUCCESS';
export const DELETE_REPORT_ERROR = 'DELETE_REPORT_ERROR';
export const UPDATE_REPORT = 'UPDATE_REPORT';
export const UPDATE_REPORT_SUCCESS = 'UPDATE_REPORT_SUCCESS';
export const UPDATE_REPORT_ERROR = 'UPDATE_REPORT_ERROR';
export const ARCHIVE_REPORT = 'ARCHIVE_REPORT';
export const ARCHIVE_REPORT_SUCCESS = 'ARCHIVE_REPORT_SUCCESS';
export const ARCHIVE_REPORT_ERROR = 'ARCHIVE_REPORT_ERROR';
export const HIDE_REPORT = 'HIDE_REPORT';
export const HIDE_REPORT_SUCCESS = 'HIDE_REPORT_SUCCESS';
export const HIDE_REPORT_ERROR = 'ARCHIVE_REPORT_ERROR';
export const SET_REPORT = 'SET_REPORT';
export const CLOSE_REPORT = 'CLOSE_REPORT';

// FEEDBACKS
export const LOAD_FEEDBACKS = 'LOAD_FEEDBACKS';
export const LOAD_FEEDBACKS_SUCCESS = 'LOAD_FEEDBACKS_SUCCESS';
export const LOAD_FEEDBACKS_ERROR = 'LOAD_FEEDBACKS_ERROR';
export const LOAD_FEEDBACK = 'LOAD_FEEDBACK';
export const LOAD_FEEDBACK_SUCCESS = 'LOAD_FEEDBACK_SUCCESS';
export const LOAD_FEEDBACK_ERROR = 'LOAD_FEEDBACK_ERROR';
export const LOAD_FEEDBACKS_MAP = 'LOAD_FEEDBACKS_MAP';
export const LOAD_FEEDBACKS_MAP_SUCCESS = 'LOAD_FEEDBACKS_MAP_SUCCESS';
export const LOAD_FEEDBACKS_MAP_ERROR = 'LOAD_FEEDBACKS_MAP_ERROR';
export const LOAD_ALL_FEEDBACKS_MAP = 'LOAD_ALL_FEEDBACKS_MAP';
export const LOAD_ALL_FEEDBACKS_MAP_SUCCESS = 'LOAD_ALL_FEEDBACKS_MAP_SUCCESS';
export const LOAD_ALL_FEEDBACKS_MAP_ERROR = 'LOAD_ALL_FEEDBACKS_MAP_ERROR';
export const LOAD_FEEDBACKS_PHOTOS = 'LOAD_FEEDBACKS_PHOTOS';
export const LOAD_FEEDBACKS_PHOTOS_SUCCESS = 'LOAD_FEEDBACKS_PHOTOS_SUCCESS';
export const LOAD_FEEDBACKS_PHOTOS_ERROR = 'LOAD_FEEDBACKS_PHOTOS_ERROR';
export const LOAD_PHOTO_TAGS = 'LOAD_PHOTO_TAGS';
export const LOAD_PHOTO_TAGS_SUCCESS = 'LOAD_PHOTO_TAGS_SUCCESS';
export const LOAD_PHOTO_TAGS_ERROR = 'LOAD_PHOTO_TAGS_ERROR';

// ANSWER IDENTIFIERS
export const LOAD_ANSWER_IDENTIFIERS = 'LOAD_ANSWER_IDENTIFIERS';
export const LOAD_ANSWER_IDENTIFIERS_SUCCESS = 'LOAD_ANSWER_IDENTIFIERS_SUCCESS';
export const LOAD_ANSWER_IDENTIFIERS_ERROR = 'LOAD_ANSWER_IDENTIFIERS_ERROR';

// GALLERY
export const LOAD_GALLERY = 'LOAD_GALLERY';
export const LOAD_GALLERY_SUCCESS = 'LOAD_GALLERY_SUCCESS';
export const LOAD_GALLERY_ERROR = 'LOAD_GALLERY_ERROR';

// CAMPAIGNS
export const LOAD_CAMPAIGNS = 'LOAD_CAMPAIGNS';
export const LOAD_CAMPAIGNS_SUCCESS = 'LOAD_CAMPAIGNS_SUCCESS';
export const LOAD_CAMPAIGNS_ERROR = 'LOAD_CAMPAIGNS_ERROR';
export const LOAD_CAMPAIGN = 'LOAD_CAMPAIGN';
export const LOAD_CAMPAIGN_SUCCESS = 'LOAD_CAMPAIGN_SUCCESS';
export const LOAD_CAMPAIGN_ERROR = 'LOAD_CAMPAIGN_ERROR';

// COMPANIES
export const LOAD_COMPANIES = 'LOAD_COMPANIES';
export const LOAD_COMPANIES_SUCCESS = 'LOAD_COMPANIES_SUCCESS';
export const LOAD_COMPANIES_ERROR = 'LOAD_COMPANIES_ERROR';
export const LOAD_COMPANY = 'LOAD_COMPANY';
export const LOAD_COMPANY_SUCCESS = 'LOAD_COMPANY_SUCCESS';
export const LOAD_COMPANY_ERROR = 'LOAD_COMPANY_ERROR';
export const SET_COMPANY = 'SET_COMPANY';

// WIDGETS
export const LOAD_WIDGETS_LIST = 'LOAD_WIDGETS_LIST';
export const LOAD_WIDGETS_LIST_SUCCESS = 'LOAD_WIDGETS_LIST_SUCCESS';
export const LOAD_WIDGETS_LIST_ERROR = 'LOAD_WIDGETS_LIST_ERROR';
export const LOAD_WIDGET_DATA = 'LOAD_WIDGET_DATA';
export const LOAD_WIDGET_DATA_SUCCESS = 'LOAD_WIDGET_DATA_SUCCESS';
export const LOAD_WIDGET_DATA_ERROR = 'LOAD_WIDGET_DATA_ERROR';
export const LOAD_WIDGET_FEEDBACKS = 'LOAD_WIDGET_FEEDBACKS';
export const LOAD_WIDGET_FEEDBACKS_SUCCESS = 'LOAD_WIDGET_FEEDBACKS_SUCCESS';
export const LOAD_WIDGET_FEEDBACKS_ERROR = 'LOAD_WIDGET_FEEDBACKS_ERROR';
export const LOAD_WIDGET_PREVIEW = 'LOAD_WIDGET_PREVIEW';
export const LOAD_WIDGET_PREVIEW_SUCCESS = 'LOAD_WIDGET_PREVIEW_SUCCESS';
export const LOAD_WIDGET_PREVIEW_ERROR = 'LOAD_WIDGET_PREVIEW_ERROR';
export const CREATE_WIDGET = 'CREATE_WIDGET';
export const CREATE_WIDGET_SUCCESS = 'CREATE_WIDGET_SUCCESS';
export const CREATE_WIDGET_ERROR = 'CREATE_WIDGET_ERROR';
export const UPDATE_WIDGET = 'UPDATE_WIDGET';
export const UPDATE_WIDGET_SUCCESS = 'UPDATE_WIDGET_SUCCESS';
export const UPDATE_WIDGET_ERROR = 'UPDATE_WIDGET_ERROR';
export const BULK_UPDATE_WIDGET = 'BULK_UPDATE_WIDGET';
export const BULK_UPDATE_WIDGET_SUCCESS = 'BULK_UPDATE_WIDGET_SUCCESS';
export const BULK_UPDATE_WIDGET_ERROR = 'BULK_UPDATE_WIDGET_ERROR';
export const DELETE_WIDGET = 'DELETE_WIDGET';
export const DELETE_WIDGET_SUCCESS = 'DELETE_WIDGET_SUCCESS';
export const DELETE_WIDGET_ERROR = 'DELETE_WIDGET_ERROR';

// CURRENT USER
export const LOAD_CURRENT_USER = 'LOAD_CURRENT_USER';
export const LOAD_CURRENT_USER_ERROR = 'LOAD_CURRENT_USER_ERROR';
export const LOAD_CURRENT_USER_SUCCESS = 'LOAD_CURRENT_USER_SUCCESS';

// NETWORK EXCEPTIONS
export const RECEIVE_NETWORK_EXCEPTION = 'RECEIVE_NETWORK_EXCEPTION';
